import * as types from './constants';
import { convertArrayToObject } from '../../utils/arrayConvert';

const initialState = {
  listData: {
    dataTable: [],
    loading: false,
    message: null,
    count: 0,
    next: null,
    previous: null,
    curr_page: 1,
    errors_api: {},
    queryParsed: false
  },
  deleteData: {
    data: {},
    loading: false,
    errors_api: false
  },
  columnsMemory: {}
};

const actions = {
  // Get Members
  [types.GET_MEMBERS_REQUEST]: state => {
    const data = {
      ...state,
      listData: { ...state.listData, loading: true }
    };

    return { ...data };
  },

  [types.GET_MEMBERS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        ...payload,
        loading: false
      }
    };

    return { ...data };
  },

  [types.GET_MEMBERS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      listData: { ...state.listData, loading: false, errors_api: payload }
    };

    return { ...data };
  },

  // Delete Member
  [types.DELETE_MEMBER_REQUEST]: state => {
    const data = {
      ...state,
      deleteData: { ...state.deleteData, loading: true }
    };

    return { ...data };
  },

  [types.DELETE_MEMBER_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      deleteData: { ...state.deleteData, loading: false, data: payload }
    };

    return { ...data };
  },

  [types.DELETE_MEMBER_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      deleteData: { ...state.deleteData, loading: false, errors_api: payload }
    };

    return { ...data };
  },

  [types.DELETE_MEMBER_RESET]: state => {
    const data = {
      ...state,
      deleteData: initialState.deleteData
    };

    return { ...data };
  },

  // Save Columns Width
  [types.SAVE_MEMBERS_COLUMNS]: (state, { payload }) => {

    const data = {
      ...state,
      columnsMemory: convertArrayToObject(state.columnsMemory, payload)
    };

    return { ...data };
  },

  // Operations
  [types.MEMBERS_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      listData: { ...state.listData, curr_page: parseInt(payload) || 1, queryParsed: true }
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};